import styles from './DashboardBlock.module.scss';
import cn from 'classnames';

interface IDashboardBlockProps {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  blockClassName?: string;
}

const DashboardBlock = ({
  title,
  actions,
  blockClassName,
  children,
}: IDashboardBlockProps) => {
  return (
    <div className={cn(styles.dashboardBlock, blockClassName)}>
      <div className={styles.dashboardBlockHead}>
        <span className={styles.dashboardBlockTitle}>{title}</span>
        {actions}
      </div>
      <div className={styles.children}>{children}</div>
    </div>
  );
};

export default DashboardBlock;
